<template>
  <fct-autocomplete style="width: 100%" id="physical-address" :value="value" @input="val => $emit('input', val)"
                    :onInputChange="placeAutoComplete"></fct-autocomplete>
</template>

<script>
  import GoogleResource from '../resources/googleResource';

  export default {
    props: ['value', 'country'],
    methods: {
      placeAutoComplete(text) {
        return GoogleResource.placeAutoComplete({text, country: this.country});
      }
    }
  };
</script>

<style scoped>

</style>
